var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.state.color}},[_vm._v(" "+_vm._s(_vm.state.icon)+" ")]),_c('span',[_vm._v(_vm._s(_vm.$t('labels.subscription-state.label'))+" "),_c('b',[_vm._v(_vm._s(_vm.$t(_vm.state.label)))]),_vm._v(".")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }